import { useQuery } from '@tanstack/react-query';
import { PermissionsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function usePermissionsControllerGetPermissionByIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['permissionsControllerGetPermissionById', accessControlScope, args],
        queryFn: async () => {
            const api = new PermissionsApi(accessControlConfig);
            return api.permissionsControllerGetPermissionById(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=usePermissionsControllerGetPermissionByIdQuery.js.map